import { useState } from "react";
import { useDispatch } from "react-redux";
import { useMatch, useNavigate } from "react-router-dom";

import { filterBySearch } from "../../features/filter/filterSlice";
import SearchIcon from "../UI/SvgIcons/SearchIcon";

const Search = () => {
  const [text, setText] = useState("");

  const dispatch = useDispatch();

  const match = useMatch("/");
  const navigate = useNavigate();

  const handleChange = (e) => {
    setText(e.target.value);
    dispatch(filterBySearch(e.target.value));
    if (!match) navigate("/");
  };

  return (
    <form className="flex items-center">
      <div className="group relative rounded-md bg-white">
        <SearchIcon />
        <input
          type="text"
          placeholder="Filter books..."
          className="search"
          id="lws-search"
          value={text}
          onChange={handleChange}
        />
      </div>
    </form>
  );
};

export default Search;
